import React from 'react';
import PropTypes from 'prop-types';
import {useDispatch} from 'react-redux';
import {FlexContainer} from 'components/layout';
import {
  hybridHoldExpiresAt,
  isHybridBookingPending,
  isHybridHoldRunning
} from 'helpers/functionUtils/hybridDelivery';
import useCountdown from 'routes/App/ordersV2/OrderDetails/DriverOptOut/useCountdown';
import DriverOptOutAction from 'routes/App/ordersV2/OrderDetails/DriverOptOut/DriverOptOutAction';
import {RUN_GET_ACTIVE_ORDERS_JOB} from 'store/global/ordersV2/action';

// The countdown lives here so the action disappears the moment the window
// closes, instead of waiting for the next list refresh.
const DriverOptOutCell = ({order, serviceFeatures}) => {
  const dispatch = useDispatch();
  const {seconds} = useCountdown(hybridHoldExpiresAt(order));

  const isRunning = isHybridHoldRunning(order, serviceFeatures) && !!seconds;
  // Stays mounted while the booking is pending so a request fired in the last
  // seconds still has somewhere to report its failure.
  if (!isRunning && !isHybridBookingPending(order, serviceFeatures)) {
    return null;
  }

  return (
    <FlexContainer className='justify-end'>
      <DriverOptOutAction
        className='ButtonSmall solid nowrap'
        order={order}
        canSwitch={isRunning}
        onSuccess={() => dispatch(RUN_GET_ACTIVE_ORDERS_JOB())}
      />
    </FlexContainer>
  );
};

DriverOptOutCell.propTypes = {
  order: PropTypes.shape({}).isRequired,
  serviceFeatures: PropTypes.arrayOf(PropTypes.string)
};

DriverOptOutCell.defaultProps = {
  serviceFeatures: []
};

export default DriverOptOutCell;
